import { PropsWithChildren, useState } from 'react';

import { AllPairedCostAdjustmentSummaryTypes } from '../types.js';
import { PairedCostAdjustmentSummaryModalContext } from './PairedCostAdjustmentSummaryModalContext.js';

export const PairedCostAdjustmentSummaryModalContextProvider = ({
  children,
}: PropsWithChildren) => {
  const [pairedCostModal, setPairedCostModal] =
    useState<AllPairedCostAdjustmentSummaryTypes | null>(null);

  return (
    <PairedCostAdjustmentSummaryModalContext.Provider
      value={{ pairedCostModal, setPairedCostModal }}
    >
      {children}
    </PairedCostAdjustmentSummaryModalContext.Provider>
  );
};
